export const AdvisorApplicationName = 'advisor';
export const UrlParam_EhrId = 'ehr-id';
export const UrlParam_FacilityId = 'facility-id';
export const UrlParam_EnvironmentId = 'environment-id';
export const UrlParam_UserType = 'user-type';
export const Key_StorageArtifactVersion = 'storage__artifact-version';
export const avatarMode = 'avatar-mode';
//# sourceMappingURL=consts.js.map